export const OptionResultadosData = [
  {
    title: "Mis laboratorios",
    icon: "MisLaboratoriosIcon",
    link: "/misLaboratorios",
    subMenuItems: [],
    key: 10
  },
  {
    title: "Mis informes",
    icon: "MiInformeIcon",
    link: "/misInformes",
    subMenuItems: [],
    key: 11
  },
];
